// extracted by mini-css-extract-plugin
module.exports = {"listTitle":"PersonalInfo_listTitle_27WAH"};